import { render, staticRenderFns } from "./ModalBackofficeAlterarMedico.vue?vue&type=template&id=2f3a953e&scoped=true"
import script from "./ModalBackofficeAlterarMedico.vue?vue&type=script&lang=ts"
export * from "./ModalBackofficeAlterarMedico.vue?vue&type=script&lang=ts"
import style0 from "./ModalBackofficeAlterarMedico.vue?vue&type=style&index=0&id=2f3a953e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3a953e",
  null
  
)

export default component.exports